import { get } from 'lodash-es';

export const SECT_VALUES = {
  2026: [{ type: 'electric-truck', value: 'riviantoprated' }],
};

export function getSectValues(year, type) {
  const values = get(SECT_VALUES, `${year}`, []).filter(obj => obj.type === type);

  return values.length && values[0].value;
}
